module.exports = __webpack_public_path__ + "static/media/Trading_Up_Tablet_Banner_STAKE@2x.88cec6fa.webp";